import React, { useState } from "react"
import { Box } from "../../box"
import { Button } from "../button"
import { Minus } from "../../icons/Minus"
import { Union } from "../../icons/union"
import { Text } from "../../text"

export type AccordionProps = {
  header: string | React.ReactNode
  children?: React.ReactNode | null
  className?: string
}

export function Accordion({ children, className = "", header }: AccordionProps) {
  const [isOpen, toggleOpen] = useState(false)

  return (
    <Box className={[`w-full rounded-box mb-3 ${isOpen && "bg-black/10"}`, className].join(" ")}>
      <div
        className={`flex flex-row rounded-box p-4 justify-between items-center w-full cursor-pointer ${
          !isOpen && "bg-white/5"
        }`}
        onClick={() => toggleOpen(!isOpen)}
      >
        <Text as="h3" size="table" weight="medium">
          {header}
        </Text>
        <Button type="icon" noPadding className="bg-white p-2 md:p-2.5 shadow-md ml-2">
          <span className="hidden md:flex">{isOpen ? <Minus /> : <Union />}</span>
          <span className="flex md:hidden">{isOpen ? <Minus w={9} h={9} /> : <Union w={9} h={9} />}</span>
        </Button>
      </div>
      {isOpen && <Box className="w-full pb-4 px-4 md:pr-10">{children}</Box>}
    </Box>
  )
}
